{{#each status}}
<li>
	<a href='#search?filter=%7B"status"%3A%5B"{{status}}"%5D%7D'>
		<i class="fa fa-circle {{class}} m-r-5"></i> {{text}} (<span class="js-device-{{status}}"></span>)
	</a>
</li>
{{/each}}
